var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileRenamedIcon = function SvgFileRenamedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      fill: "none"
    },
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.35,
    d: "M16.406 5.594s.49-.854 2.938-.854m-2.938.854s-.49-.854-2.937-.854m2.937.854v2.562m0 10.25s.49.854 2.938.854m-2.938-.854s-.49.854-2.937.854m2.937-.854v-2.562m0-7.688h3.396a1.5 1.5 0 0 1 1.5 1.5v4.688a1.5 1.5 0 0 1-1.5 1.5h-3.396m0-7.688v7.688M13.47 8.156H4.198a1.5 1.5 0 0 0-1.5 1.5v4.688a1.5 1.5 0 0 0 1.5 1.5h9.27",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgFileRenamedIcon;